import { useEffect } from 'react'

/** OAuth 4-leg redirect 의 4단계: provider 로그인 완료 후 backend `/oauth/v1/{p}/callback` 이
 *  cookie set 후 여기로 redirect (`?success=true` 또는 `?error=...`).
 *  sessionStorage 의 oauth_return_url 읽고 같은 origin 이면 그곳으로 복귀. */
export function OAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('success') !== 'true') {
      window.location.replace('/login?error=' + (params.get('error') || 'unknown'))
      return
    }
    const stored = sessionStorage.getItem('oauth_return_url')
    if (stored) {
      sessionStorage.removeItem('oauth_return_url')
      try {
        const url = new URL(stored, window.location.origin)
        if (url.origin === window.location.origin) {
          window.location.replace(stored)
          return
        }
      } catch { /* fallthrough */ }
    }
    window.location.replace('/groups')
  }, [])
  return (
    <main className="content" style={{ textAlign: 'center', paddingTop: 80 }}>
      <h2>Signing in…</h2>
    </main>
  )
}
